import { HeaderContainer, LeftSide, ManageSubscription, RightSide } from "./Header.styled";
import { Period } from "../../../PricingActualPage/Period";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface HeaderProps {}

export const Header = ({}: HeaderProps) => {
	const navigate = useNavigate();

	const { t } = useTranslation();

	const handleOnManage = () => {
		navigate("/cabinet/my-subscriptions");
	};

	return (
		<HeaderContainer>
			<LeftSide>
				<Period />
			</LeftSide>

			<RightSide>
				<ManageSubscription onClick={handleOnManage}>{t("pages.pricing.manage_subscriptions")}</ManageSubscription>
			</RightSide>
		</HeaderContainer>
	);
};
